import { MODAL_CLOSE } from '@/const';
import _ from 'lodash';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

const activeModal = ref('');

function openModal(value) {
  activeModal.value = value;
}
function closeModal() {
  activeModal.value = null;
}

export default function useModal() {
  return {
    activeModal,
    openModal,
    closeModal
  };
}


/**
 * Новый стор
 *
 * отображает только глобально зарегистрированные компоненты
 */
export const useModalStore = defineStore('modal', () => {
  const modalResolve = ref(null);
  const activeModal = ref(null);
  const modalParams = ref({});

  const keepAliveIncludes = ref(new Set());

  const keepAliveComponents = computed(() =>
    Array.from(keepAliveIncludes.value)
  );

  function openModal(componentName, params, keepAlive = false) {
    activeModal.value = componentName;
    modalParams.value = params;

    if (keepAlive) {
      keepAliveIncludes.value.add(componentName);
    }

    return new Promise((resolve) => (modalResolve.value = resolve));
  }

  function modalEmit(event, params) {
    if (!_.isFunction(modalResolve.value)) {
      throw new Error('There is no active modal window');
    }

    modalResolve.value({ event, params });
  }

  function closeModal() {
    modalResolve.value = null;
    activeModal.value = null;
    modalParams.value = {};

    if (_.isFunction(modalResolve.value)) {
      modalResolve.value({ event: MODAL_CLOSE });
    }
  }

  return {
    activeModal,
    modalParams,
    keepAliveComponents,

    openModal,
    modalEmit,
    closeModal,
  };
});
